import {React, useEffect} from "react";
import "./style/BaseModal.css"

export default function BaseModal({ headerName, children, show, onClose }) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  
  return (
    <>
      <div
        className={`backdrop ${show ? "show" : ""}`}
        onClick={onClose}
      ></div>

      <div className={`base-modal ${show ? "show" : ""}`}>
        <div className="modal-top"></div>
        <div className="modal-header-wrapper">
          <div className="modal-header">
            <span className="header-span">{headerName}</span>
          </div>
          <button className="header-close-btn" onClick={onClose}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.28033 0.21967C0.987437 -0.0732233 0.512563 -0.0732233 0.21967 0.21967C-0.0732233 0.512563 -0.0732233 0.987437 0.21967 1.28033L5.68934 6.75L0.21967 12.2197C-0.0732233 12.5126 -0.0732233 12.9874 0.21967 13.2803C0.512563 13.5732 0.987437 13.5732 1.28033 13.2803L6.75 7.81066L12.2197 13.2803C12.5126 13.5732 12.9874 13.5732 13.2803 13.2803C13.5732 12.9874 13.5732 12.5126 13.2803 12.2197L7.81066 6.75L13.2803 1.28033C13.5732 0.987437 13.5732 0.512563 13.2803 0.21967C12.9874 -0.0732233 12.5126 -0.0732233 12.2197 0.21967L6.75 5.68934L1.28033 0.21967Z" fill="currentColor"/>
            </svg>
          </button>
        </div>

        <div className="model-content">
          { children }
        </div>
      </div>
    </>
  );
}